import * as React from 'react'
import { Portal } from 'react-portal'
import cn from 'classnames'
import OutsideClickHandler from 'react-outside-click-handler'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'
import styles from './styles.module.scss'
import { commonKeyValues } from '../../lib/utils'

interface IPopupProps {
  onClose: () => void
  children: React.ReactNode
  closeIcon?: boolean
  style?: React.CSSProperties
  contentStyle?: React.CSSProperties
  center?: boolean
}

const Popup = ({ children, onClose, closeIcon = false, style, contentStyle, center }: IPopupProps) => {
  const [closing, setClosing] = React.useState(false)

  const close = () => {
    setClosing(true)
    setTimeout(() => {
      onClose()
      setClosing(false)
    }, 500)
  }

  return (
    <Portal>
      <div
        className={cn(styles.popupWrapper, closing && styles.popupWrapperClosing, center && styles.popupWrapperCenter)}
        style={style}
      >
        <OutsideClickHandler onOutsideClick={() => close()}>
          <div
            className={cn(
              styles.popupContent,
              closing && styles.popupContentClosing,
              center && styles.popupContentCenter
            )}
            style={contentStyle}
          >
            {closeIcon && (
              <i
                className={styles.closeIcon}
                onClick={() => close()}
                onKeyDown={(e) => e.keyCode === commonKeyValues.enter && close()}
                role="button"
                tabIndex={0}
              >
                <FontAwesomeIcon icon={faTimes} />
              </i>
            )}
            {children}
          </div>
        </OutsideClickHandler>
      </div>
    </Portal>
  )
}

export default Popup
